import { Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import "./css/main.less";
import { HttpVerb, HttpDataService } from "./my-settings/http-data.service";
import { Subscription } from "rxjs/Rx";
import { locale as enLang } from './my-settings/shared/assets/i18n/en';
import { locale as frLang } from './my-settings/shared/assets/i18n/fr';
import { locale as esLang } from './my-settings/shared/assets/i18n/es';
import { NgxTranslateService } from "./my-settings/shared/ngx-translate.service";
import { WhiteLabelService } from "./my-settings/white-label/white-label.service";

@Component({
  selector: "my-app",
  template: require('./app.component.html')
})
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
  busy: Subscription;
  constructor(private translateService: NgxTranslateService,
    private whiteLabelService: WhiteLabelService) {
    //register translations
    this.translateService.loadTranslations(
      enLang,
      esLang,
      frLang
    );
  }
  ngOnInit() {
    this.translateService.getSelectedLanguage();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.component.ts